<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{'webkassaCashboxes.orgAuth.title' | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>

<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
  <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'webkassaCashboxes'; scope: 'webkassa-cashboxes'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('orgAuth.form.organizationId')}}</nz-form-label>
          <nz-form-control>
            <hx-org-select formControlName="organizationId"></hx-org-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('orgAuth.form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="enabled">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('orgAuth.form.login')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="login"/>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('orgAuth.form.password')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="password"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label>{{tr('orgAuth.form.token')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="token"/>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label>{{tr('orgAuth.form.tokenDate')}}</nz-form-label>
          <nz-form-control>
            <nz-date-picker nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss" formControlName="tokenDate"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model?.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
